import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import PropTypes from 'prop-types'

import * as Sc from './ClassroomForm.style'
import {
  BottomActionBar,
  BottomActionBarWrapper,
} from 'components/BottomActionBar'
import Button from 'components/Button'
import Radio from 'components/Radio'
import { Row } from 'components/Row'
import Title from 'components/Title'
import { fetchClassroomsAvailableAction } from 'store/actions/student.actions'

const ClassroomForm = ({ onCancel, onSubmit }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { newStudent } = useSelector(({ students }) => students)
  const { availableClassrooms, courseName, levelName, name } = newStudent || {}
  const [selected, setSelected] = useState([])

  const setCoursesList = async () => {
    await dispatch(fetchClassroomsAvailableAction())
  }

  useEffect(() => {
    setCoursesList()
  }, [])

  const handleChange = (classroom) => {
    setSelected(classroom)
  }

  const handleSubmit = () => {
    onSubmit(selected)
  }

  return (
    <BottomActionBarWrapper>
      {availableClassrooms?.length && (
        <Sc.Container>
          <Title
            subtitle={t(
              'Si su línea no aparece arriba comunícaselo a su profesor/a'
            )}
            title={t('¿A qué línea de {{_COURSE}} {{_LEVEL}} va {{name}}?', {
              _COURSE: t(courseName),
              _LEVEL: t(levelName),
              name,
            })}
          />
          <Row>
            {availableClassrooms.map((classroom) => (
              <Radio
                checked={!!selected && selected.id === classroom.id}
                id={classroom.id}
                key={classroom.id}
                name='classrooms'
                onChange={() => handleChange(classroom)}
                onClick={() => handleChange(classroom)}
                value={classroom.id}
              >
                {t(classroom.name)}
              </Radio>
            ))}
          </Row>
          <BottomActionBar>
            <Button classes={{ second: true }} onPress={onCancel}>
              {t('No unirme a ninguna clase')}
            </Button>
            <Button disabled={!selected} onPress={handleSubmit}>
              {t('Finalizar')}
            </Button>
          </BottomActionBar>
        </Sc.Container>
      )}
    </BottomActionBarWrapper>
  )
}

ClassroomForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default ClassroomForm
